import React, { Component } from 'react'

import playerAvatar from "../../../../assets/img/demo/player-avatar-99.png";
import "../../../../assets/sass/pages/evaluation-report.scss";
import { ReactComponent as ShareIcon } from '../../../../assets/svg/actions/icn-share-16px.svg'

import MainContent from './MainContent';

import PlayerBasicInformationCard from '../../../ui/cards/PlayerBasicInformationCard';
import GenerateReportModal from '../../../ui/modals/GenerateReportModal';
import { Row, Col, Button } from 'react-bootstrap';
import Tools from "../../../../Tools";
import SA_ConfirmDelete from '../../../ui/sweetalert/SA_ConfirmDelete';
import ShareReportModal from './components/ShareReportModal';

class EvaluationReport extends Component {
    constructor(props) {
        super(props)

        Tools.redirectToErrorPage(props, ['scouting', 'my-scouting']);

        this.state = {
            showGenerateReportModal: false,
        }
    }

    /**
     * Renders
     */

    render() {
        return (
            <div className="evaluation-report">
                {this.renderPageHeader()}
                {this.renderProfileHeader()}
                {this.renderEvaluationSummaryBar()}
                {this.renderMainContent()}
                {this.renderModals()}
            </div>
        )
    }

    renderPageHeader = () => {
        return (
            <Row>
                <Col md={6}>
                    {this.renderPlayerName()}
                </Col>
                <Col md={6}>
                    {this.renderActionButtons()}
                </Col>
            </Row>
        )
    }

    renderPlayerName = () => {
        const { playerName } = this.props;
        return (
            <div className="player-name">
                {playerName}
            </div>
        );
    };

    renderActionButtons = () => {
        return (
            <div className="action-buttons">
                <Row className="gutters-8">
                    <Col md={3}>
                        <Button
                            variant="link"
                            className="sm"
                            onClick={() => this.handleDeleteEvaluation()}
                        >Delete Evaluation</Button>
                    </Col>
                    <Col md={3}>
                        <Button
                            variant="secondary"
                            className="sm"
                            onClick={() => this.handleReEvaluate()}
                        >Re-Evaluate</Button>
                    </Col>
                    <Col md={5}>
                        <Button
                            variant="primary"
                            className="sm"
                            onClick={() => this.toggleGenerateReportModal(true)}
                        >Generate and Download Report</Button>
                    </Col>
                    <Col md={1}>
                        <Button
                            variant="link"
                            className="sm share-icon"
                            onClick={() => this.toggleShareReportModal(true)}
                        ><ShareIcon /></Button>
                    </Col>
                </Row>
            </div>
        )
    }

    renderProfileHeader = () => {
        return (
            <EvaluationReport.Header 
                avatar={playerAvatar}
                items={[
                    {title: "Playing Position", value: "CF, RAMF, RWF"},
                    {title: "Age", value: "24Yrs"},
                    {title: "Current Value", value: "$1M"},
                    {title: "Foot", value: "Left"},
                    {title: "Nationality", value: "Brazil"},
                    {title: "Passport", value: "Brazil"},
                    {title: "Curent Team", value: "Hardfoot FC"},
                    {title: "Contract Until", value: "01.31.2019"},
                    {title: "Int. Matches", value: "18"},
                    {title: "Int. Goals", value: "23"},
                    {title: "Total Matches", value: "89"},
                    {title: "Total Goals", value: "45"},
                    {title: "Manager/Agent", value: "Mark Henry"},
                ]}    
            />
        );
    };

    renderMainContent = () => {
        return (
            <EvaluationReport.MainContent />
        );
    }

    renderEvaluationSummaryBar = () => {
        return (
            <div className="evaluation-summary-bar">
                <div className="summary-item-container">
                    <div className="title">Overall Score</div>
                    <p className="text">86</p>
                </div>
                <div className="summary-item-container">
                    <div className="title">Overall Evaluation Comment</div>
                    <p className="text">After screen through deeply, I can comfidently say that Eduarado is amazing team palyer and ultimate ball passer. Especially when playing in the forward</p>
                </div>
            </div>
        )
    }

    renderModals = () => {
        const { showGenerateReportModal, showShareReportModal } = this.state;

        return (
            <>
                <GenerateReportModal
                    show={showGenerateReportModal}
                    onHide={() => this.toggleGenerateReportModal(false)}
                />
                <ShareReportModal
                    show={showShareReportModal}
                    onHide={() => this.toggleShareReportModal(false)}
                />
            </>
        )
    }

    /**
     * Handlers
     */

    toggleGenerateReportModal = (show) => {
        this.setState({
            showGenerateReportModal: show
        })
    }

    toggleShareReportModal = (show) => {
        this.setState({
            showShareReportModal: show
        })
    }

    handleDeleteEvaluation = () => {
        const deleteModal = new SA_ConfirmDelete();
        deleteModal.fire().then(result => {
            if(result.value) this.props.history.push(`/scouting`);
        })
    }

    handleReEvaluate = () => {
        const id = '';
        this.props.history.push(`/scouting/player-evaluation/${id}`);
    }

    static defaultProps = {
        // TODO: remove it
        playerName: "Eduardo Miles",
    };
}

EvaluationReport.Header = PlayerBasicInformationCard;
EvaluationReport.MainContent = MainContent;

export default EvaluationReport;